//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
import dayjs from "dayjs";
import { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router";
import { _commaFormatter } from "../../controllers";
import { LOCATIONS } from "../../utils/global_variables";

const DiiTable = ({ trayExpanded, diiData, ...propsWithBsClassName }) => {


    const location = useLocation()
    return (

        <Container fluid className='p-0'>
            <Row className='g-0 my-3'>
                <Col>
                    <div className='font-regular font-size2 color-subtext px-2'>*All values are in Crores</div>
                </Col>
            </Row>

            <div className={`${location.pathname === LOCATIONS.DASHBOARD ? "scanners-table-container pe-1" : trayExpanded ? 'scanners-side-tray-table-expand-container' : 'scanners-side-tray-table-container'}`}>
                {diiData?.length > 0 && diiData?.map(data => (
                    <div className='table-responsive mb-2'>
                        <table className='table table-hover table-striped scanners-table bdr'>
                            <thead>
                                <tr>
                                    {[data?.TransactionDate, 'Buy Value', 'Sell Value', 'Net Value']?.map((element, i) =>
                                        <th className='font-regular font-size1 table-th-color-text text-center col-3 text-truncate bdr-rgt'>
                                            {element === data?.FIIDate ? dayjs(element)?.format('DD MMM \'YY') : element}
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                   <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>Equity</td>
                                   <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{_commaFormatter(data?.BuyValue)}</td> 
                                   <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{_commaFormatter(data?.SellValue)}</td> 
                                   <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{_commaFormatter(data?.NetValue)}</td> 
                                </tr>                                
                            </tbody>
                        </table>
                   </div>
                ))
                }
            </div>
        </Container>

    );

};

export default memo(DiiTable);
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End